import { render, staticRenderFns } from "./SanitizeAllow.vue?vue&type=template&id=188e7f32&"
import script from "./SanitizeAllow.vue?vue&type=script&lang=js&"
export * from "./SanitizeAllow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports